// extracted by mini-css-extract-plugin
module.exports = {"label":"NodeLabel-module--label--2tN5c","labelCollapsed":"NodeLabel-module--labelCollapsed--1nVK-","circleWrapper":"NodeLabel-module--circleWrapper--1zTRy"};